<div class="card card-grey card-form">
  <div class="d-flex justify-content-center w-100 mb-2"><img src="/assets/images/link.png" alt="link image"></div>

  <ng-container *ngIf="!errorSubscription && !loadingSubscription; else innerSubLoading">
    <ng-container *ngIf="!(isAlreadySubscribed && !isTrialing)" class="w-100">
      <div class="w-100">
        <div class="form">
          <div class="alert alert-secondary w-100" role="alert">
            <p>Vous devez être abonné pour bénéficier de notre annuaire professionnel MonSuiviDiet Plus.</p>
          </div>

          <button (click)="goSubscription()" class="btn btn-primary btn-gradient text-icon submit-button">
            Abonnement
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isAlreadySubscribed && !isTrialing">
      <div *ngIf="(dietitianState$ | async)?.entity !== undefined; else loading" class="w-100">
        <div *ngIf="isLinked()" class="form">
          <div class="alert alert-secondary w-100" role="alert">
            <p>Votre compte MonSuiviDiet est actuellement associer à un compte MonSuiviDiet Plus :</p>
            <ul *ngIf="dietitian">
              <li>Date de l'association au compte MonSuiviDiet Plus : {{(dietitian?.msdpLinkedAt) | dateToString}}</li>
            </ul>
          </div>

          <div class="d-flex justify-content-between">
            <button (click)="openMsdp()" [disabled]="submitted" class="btn btn-primary btn-gradient text-icon submit-button">
              <ng-container *ngIf="submitted; else linkButtonLabel">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Chargement...</span>
              </ng-container>
              <ng-template #linkButtonLabel>
                Ouvrir MonSuiviDiet Plus
                <i i-bs name="arrow-up-right-square" width="15" height="15"></i>
              </ng-template>
            </button>

<!--                        <button (click)="unlink()" class="btn btn-danger btn-gradient text-icon submit-button">-->
<!--                          Dissocier votre compte de MonSuiviDiet Plus-->
<!--                          <i i-bs name="box-arrow-right" width="15" height="15"></i>-->
<!--                        </button>-->
          </div>
        </div>

        <div *ngIf="!isLinked()" class="form">
          <div class="navigation-wrapper" id="navigation-wrapper">
            <msd-navigation-button *ngFor="let item of segmentedItems" (click)="onSegmentChange(item)"
                                   [title]="item.name"
                                   [isActive]="item.isActive"
                                   [icon]="item.icon"
                                   [isInternal]="true"
                                   class="mt-3">
            </msd-navigation-button>
          </div>

          <div *ngIf="segmentedItems[0].isActive">
            <div class="form-field">
              <label>Prénom</label>
              <input [(ngModel)]="firstname" [class.is-invalid]="firstNameInvalid(firstname)"
                     type="text" class="form-control">
              <div *ngIf="firstNameInvalid(firstname)" class="invalid-feedback">
                Veuillez saisir votre prénom.
              </div>
            </div>
            <div class="form-field">
              <label>Nom</label>
              <input [(ngModel)]="lastname" [class.is-invalid]="lastNameInvalid(lastname)"
                     type="text" class="form-control">
              <div *ngIf="lastNameInvalid(lastname)" class="invalid-feedback">
                Veuillez saisir votre nom.
              </div>
            </div>
            <div class="form-field">
              <label>Téléphone</label>
              <input [(ngModel)]="phoneNumber" [class.is-invalid]="phoneNumberInvalid(phoneNumber)"
                     type="text" class="form-control">
              <div *ngIf="phoneNumberInvalid(phoneNumber)" class="invalid-feedback">
                Veuillez saisir votre numéro de téléphone.
              </div>
            </div>
            <div class="form-field">
              <label>NUMÉRO ADELI ou INAMI</label>
              <input [(ngModel)]="adeliNumber" [class.is-invalid]="adeliNumberInvalid(adeliNumber)"
                     type="text" class="form-control">
              <div *ngIf="adeliNumberInvalid(adeliNumber)" class="invalid-feedback">
                Veuillez saisir votre numéro ADELI ou INAMI (de 9 à 11 chiffres).
              </div>
            </div>
            <div class="form-field">
              <label>Utilisateur MonSuiviDiet Plus</label>
              <input [(ngModel)]="email" (ngModelChange)="this.initUser = false" [class.is-invalid]="userInvalid(email)"
                     type="text" class="form-control">
              <div *ngIf="userInvalid(email)" class="invalid-feedback">
                Veuillez saisir votre compte utilisateur MonSuiviDiet Plus (adresse email).
              </div>
            </div>
            <div class="form-field">
              <label>Mot de passe MonSuiviDiet Plus</label>
              <input [(ngModel)]="password" (ngModelChange)="this.initPassword = false"
                     [class.is-invalid]="passwordInvalid(password)" class="form-control" type="password">
              <div *ngIf="passwordInvalid(password)" class="invalid-feedback">
                Veuillez saisir votre mot de passe MonSuiviDiet Plus.
              </div>
            </div>
            <div class="form-field">
              <label>Confirmation du mot de passe MonSuiviDiet Plus</label>
              <input (ngModelChange)="this.initRePassword = false"
                     [(ngModel)]="rePassword"
                     [class.is-invalid]="rePasswordInvalid(password, rePassword)"
                     class="form-control"
                     type="password">
              <div *ngIf="rePasswordInvalid(password, rePassword)" class="invalid-feedback">
                Veuillez saisir la confirmation de votre mot de passe MonSuiviDiet Plus.
              </div>
            </div>
            <button [disabled]="formInvalid() || submitted"
                    (click)="signup(firstname, lastname, phoneNumber, adeliNumber, email, password)"
                    class="btn btn-primary btn-gradient text-icon submit-button">
              <ng-container *ngIf="submitted; else signupButtonLabel">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Chargement...</span>
              </ng-container>
              <ng-template #signupButtonLabel>
                S'inscrire sur MonSuiviDiet Plus et associer ce compte
                <i i-bs name="check" width="15" height="15"></i>
              </ng-template>
            </button>
          </div>

          <div *ngIf="segmentedItems[1].isActive">
            <div class="form-field">
              <label>Utilisateur MonSuiviDiet Plus</label>
              <input [(ngModel)]="email" (ngModelChange)="this.initUser = false" [class.is-invalid]="userInvalid(email)"
                     type="text" class="form-control">
              <div *ngIf="userInvalid(email)" class="invalid-feedback">
                Veuillez saisir votre compte utilisateur MonSuiviDiet Plus (adresse email).
              </div>
            </div>
            <div class="form-field">
              <label>Mot de passe MonSuiviDiet Plus</label>
              <input [(ngModel)]="password" (ngModelChange)="this.initPassword = false"
                     [class.is-invalid]="passwordInvalid(password)" class="form-control" type="password">
              <div *ngIf="passwordInvalid(password)" class="invalid-feedback">
                Veuillez saisir votre mot de passe MonSuiviDiet Plus.
              </div>
            </div>
            <button [disabled]="formInvalid() || submitted" (click)="login(email, password)"
                    class="btn btn-primary btn-gradient text-icon submit-button">
              <ng-container *ngIf="submitted; else loginButtonLabel">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Chargement...</span>
              </ng-container>
              <ng-template #loginButtonLabel>
                Associer ce compte MonSuiviDiet Plus
                <i i-bs name="link-45deg" width="15" height="15"></i>
              </ng-template>
            </button>
          </div>
        </div>
      </div>
      <ng-template #loading>
        <ngx-inner-loading [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                           [loadingDescription]="'Chargement...'"
                           [retryButtonText]="'Réessayer'"
                           [loading]="true"
                           class="flex-center">
        </ngx-inner-loading>
      </ng-template>
    </ng-container>
  </ng-container>
  <ng-template #innerSubLoading>
    <ngx-inner-loading (retry)="loadSubscription(this.dietitian)"
                       [emptyDescription]="'Aucune souscription ...'"
                       [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'"
                       [error]="!!errorSubscription"
                       [loadingDescription]="'Chargement...'"
                       [loading]="loadingSubscription"
                       [retryButtonText]="'Réessayer'"
                       class="flex-center">
    </ngx-inner-loading>
  </ng-template>
</div>
